<template>
  <ModalFullScreen
    v-model="open"
    fullscreen
    no-click-animation
    persistent
    :retain-focus="false">
    <template #activator="{ on }">
      <sTooltip
        class="item"
        :content="$t('Tenders.CardLockedInfo')"
        :disabled="!isLocked"
        placement="top">
        <div>
          <sButton
            v-if="on && typeof on.click === 'function'"
            class="h11-links-bold pl-2  ml-auto"
            data-qa="to-criteria-templates"
            :disabled="isLocked"
            small
            type="text"
            @click="on.click">
            {{ $t('Tenders.ToCriteriaTemplates') }}
            <sIcon
              class="s-btn-icon ml-2"
              rotate="270"
              size="10"
              type="long-arrow"/>
          </sButton>
          <sButton
            v-else
            class="h11-links-bold pl-2  ml-auto"
            data-qa="to-criteria-templates"
            :disabled="isLocked"
            small
            type="text">
            {{ $t('Tenders.ToCriteriaTemplates') }}
            <sIcon
              class="s-btn-icon ml-2"
              rotate="270"
              size="10"
              type="long-arrow"/>
          </sButton>
        </div>
      </sTooltip>
    </template>
    <ComponentLayout
      id="tender-criteria-template"
      content_class="pr-7"
      fluid_main_container>
      <template #breadcrumbs>
        <TenderBreadcrumbs
          class="pt-1"
          :current_bread="{text: $t('Tenders.CriteriaTemplates') }"
          :dialog.sync="open"
          without_top_padding/>
      </template>
      <template #main_content>
        <div>
          <div class="h1-headline pb-4 text-left">
            {{ $t('Tenders.CriteriaTemplates') }}
          </div>
          <div class="h6-text text-left black--text mb-1 ">
            {{ $t('Tenders.EditCriteriaTemplateAfterSelecting') }}
          </div>
          <div class="pt-5 flex">
            <sInput
              class="search"
              data-qa="search-criteria-templates"
              debounce
              :disabled="loadingCriteriaCardTemplates"
              prefix-icon="search"
              style="max-width: 50%;"
              :value.sync="search"
              @change="searching"
              @keydown_enter.prevent="searching"
              @paste="searching"/>
          </div>
          <div
            v-if="loadingCriteriaCardTemplates"
            class="flex justify-center py-1 px-1">
            <sIcon
              class="my-5 mx-auto"
              color="var(--secondary__green_not_active)"
              size="30"
              spin
              type="loading"/>
          </div>
          <transition-group
            v-else
            class="py-1 px-1"
            name="s-zoom-in-center"
            tag="div">
            <CriterionCard
              v-for="(item, n) in cards"
              :key="n + 'card'"
              :bidding_type="tenderMutable.biddingType"
              blur_unselected
              :class="n == cards.length - 1 ? 'mb-0' : ''"
              :is_selected="cardMutable == item.code"
              :item="item"
              :open-editing="select"
              :tender="tenderMutable"
              @deleteCard="deleteCard"
              @updateCard="searching"/>
          </transition-group>
        </div>
      </template>
      <template #footer>
        <ChooseCriteriaCardFooter
          key="footer"
          :card.sync="cardMutable"
          :dialog.sync="open"
          :tender.sync="tenderMutable"
          @finish="val => $emit('finish', val)"/>
      </template>
    </ComponentLayout>
  </ModalFullScreen>
</template>
<script>
import ComponentLayout from 'pages/templates/ComponentLayout.vue'
import TenderBreadcrumbs from 'components/tenders/TenderBreadcrumbs.vue'
import CriterionCard from 'components/tenders/critetia/CriterionCard.vue'
import ChooseCriteriaCardFooter from 'components/tenders/critetia/ChooseCriteriaCardFooter.vue'

import { debounce } from 'toolkit/utils/util'

import ModalFullScreen from 'components/common/elements/ModalFullScreen.vue'

export default {
  name: 'criteriaCardsTemplate',
  data() {
    return {
      open: false,
      search: '',
      all_cards: [],
      cards: [],
      loadingCriteriaCardTemplates: false
    }
  },
  props: {
    tender: Object,
    openEditing: Function,
    isLocked: Boolean
  },
  computed: {
    tenderMutable: {
      get() {
        return this.tender
      },
      set(newValue) {
        this.$emit('update:tender', newValue)
      }
    },
    cardMutable: {
      get() {
        return this.tender.criteryCard
      },
      set(newValue) {
        const result = {...this.tenderMutable}
        result.criteryCard = newValue
        this.tenderMutable = result
      }
    },
  },
  methods: {
    searching: debounce(function () {
      if (!this.search?.trim()) {
        this.cards = this.all_cards
        return
      }
      this.cards = this.all_cards.filter(el => el.name.toLowerCase().includes(this.search.toLowerCase()) )
    }, 250),
    select(code) {
      this.openEditing(code)
      this.cardMutable = code
    },
    deleteCard(templateId) {
      this.all_cards = this.all_cards.filter(el => el.templateId != templateId )
      this.searching()
    }
  },
  watch: {
    search() {
      this.searching()
    },
    async open(val) {
      if (val) {
        this.loadingCriteriaCardTemplates = true
        this.$store.dispatch('getCriteriaCardTemplates', true)
          .then(res => {
            this.all_cards = res
            this.cards = res
          })
          .finally(() => {
            this.loadingCriteriaCardTemplates = false
          })
      }
    }
  },
  components: {
    CriterionCard,
    ModalFullScreen,
    ComponentLayout,
    TenderBreadcrumbs,
    ChooseCriteriaCardFooter
  }
}
</script>
<style lang="scss" scoped>
.search::v-deep .v-input__prepend-inner {
  padding: 4px 0;
}
</style>
